import React from 'react'

interface ArrowUpRightIconProps {
  className?: string
  stroke?: string
}

export const ArrowUpRightIcon: React.FC<ArrowUpRightIconProps> = ({
  className = 'size-[14px]',
  stroke = 'currentColor',
}) => (
  <svg
    className={className}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M2 12L12 2M12 2H4M12 2V10"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
